import styled, { css, keyframes } from 'styled-components';

interface ITooltipBoxProps {
  readonly position: string;
  showTooltip: boolean;
  textAlign: string;
}

interface IWrapCenter {
  readonly position: string;
}

interface ITooltipTarget {
  showOnFocus: boolean;
}

const fadeIn = keyframes`
  from{
    opacity: 0;
  }
  to{
    opacity: 1;
  }
`;

export const TooltipBox = styled.span<ITooltipBoxProps>`
  opacity: 0;
  z-index: -100;
  position: relative;
  background-color: #000;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 10px 8px;
  font-size: 14px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.11), 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: 0.15s;

  text-align: ${({ textAlign }) => textAlign};
  ${({ showTooltip }) => {
    if (showTooltip) {
      return css`
        animation: 0.15s ${fadeIn} forwards;
        z-index: ${Styles.zIndex.max - 200};
      `;
    }
    return css``;
  }}

  &:after {
    content: '';
    position: absolute;
    width: 5px;
    height: 5px;
    border-width: 5px;
    border-style: solid;
    border-color: #000000 transparent transparent transparent;
    left: calc(50% - 4.5px);
    bottom: -10px;
  }

  ${({ position }) => {
    switch (position) {
      case 'bottom':
        return css`
          &:after {
            border-color: transparent transparent #000000 transparent;
            left: calc(50% - 4.5px);
            top: -10px;
          }
        `;
      case 'left':
        return css`
          &:after {
            border-color: transparent transparent transparent #000000;
            left: 100%;
            bottom: calc(50% - 5px);
          }
        `;
      case 'right':
        return css`
          &:after {
            border-color: transparent #000000 transparent transparent;
            right: 100%;
            left: unset;
            bottom: calc(50% - 5px);
          }
        `;
      default:
        return css``;
    }
  }}
`;

export const TooltipWrapper = styled.div`
  position: relative;
  display: flex;
  height: 100%;
`;

export const WrapCenter = styled.div<IWrapCenter>`
  position: absolute;
  width: 200px;
  margin-left: -100px;
  display: flex;
  justify-content: center;
  align-items: center;
  left: 50%;
  bottom: calc(100% + 5px);
  pointer-events: none;

  ${({ position }) => {
    switch (position) {
      case 'bottom':
        return css`
          bottom: unset !important;
          top: calc(100% + 5px);
          color: red;
        `;
      case 'left':
        return css`
          max-width: 200px;
          margin-left: 0;
          width: 100%;
          left: unset;
          top: 50%;
          right: calc(100% + 5px);
          width: max-content;
        `;
      case 'right':
        return css`
          max-width: 200px;
          margin-left: 0;
          width: 100%;
          top: 50%;
          left: calc(100% + 5px);
          width: max-content;
        `;
      default:
        return css`
          bottom: calc(100% + 5px);
        `;
    }
  }}
`;

export const TooltipTarget = styled.button<ITooltipTarget>`
  border: none;
  background: none;
  /* This is a fix to prevent weird overflow behavior on Safari for some page width */
  padding: 1px;
  margin: -1px;
  color: inherit;
  cursor: inherit;
  display: flex;
  ${({ showOnFocus }) =>
    !showOnFocus &&
    css`
      outline: none;
    `};
`;
